import { AppThunk } from "@Store/index";
import { fetchPropertyPageDataIfNeeded } from "./propertyPageReducer";

const loadData = (props: any): AppThunk[] => [
  fetchPropertyPageDataIfNeeded(props),
  // More pre-fetched actions...
];

export default loadData;
